import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
// Using medical laboratory image from Unsplash

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="https://images.unsplash.com/photo-1582719471384-894fbb16e074?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Medical laboratory equipment" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Why Choose CYNDREMA MEDICAL LABORATORY?</h2>
            <p>Located in Port Harcourt, Rivers State, CYNDREMA MEDICAL LABORATORY LIMITED has been providing comprehensive healthcare diagnostic services with a commitment to accuracy, reliability, and patient care.</p>
            
            <div className="features">
              {[
                { icon: 'fas fa-award', title: 'Certified Excellence', desc: 'State-of-the-art equipment and certified professionals ensuring accurate diagnostic results.' },
                { icon: 'fas fa-clock', title: 'Quick Results', desc: 'Fast turnaround times for test results without compromising on accuracy and quality.' },
                { icon: 'fas fa-shield-alt', title: 'Safe & Reliable', desc: 'Strict safety protocols and quality control measures for your health and peace of mind.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '10+', label: 'Years Experience' },
              { number: '5000+', label: 'Tests Completed' },
              { number: '99%', label: 'Accuracy Rate' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;